import axios from "@/plugins/axios";

let url = "/api/v1/fairs";

export default {
    gets(_fair, data){
        return axios.get(`${url}/${_fair}/sellers`, data).then(result => result.data);
    },
}
